(function () {
'use strict';

function queryString(search = location.search) {
  const query = {};
  if (search) {
    const params = search.substring(1).split('&');
    params.forEach(item => {
      const kv = item.split('=');
      if (kv[1]) {
        query[kv[0]] = decodeURIComponent(kv[1]);
      }
    });
  }
  return query;
}







function getEnv() {
  return /staging/i.test(location.hostname) ? 'staging' : 'production';
}

function isIOS() {
  return /iPhone|iPad|iPod|iOS/ig.test(window.navigator.userAgent);
}



function versionCompare(v1, v2, options) {
  var lexicographical = options && options.lexicographical,
      zeroExtend = options && options.zeroExtend,
      v1parts = v1.split('.'),
      v2parts = v2.split('.');

  function isValidPart(x) {
    return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
  }

  if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
    return NaN;
  }

  if (zeroExtend) {
    while (v1parts.length < v2parts.length) v1parts.push('0');
    while (v2parts.length < v1parts.length) v2parts.push('0');
  }

  if (!lexicographical) {
    v1parts = v1parts.map(Number);
    v2parts = v2parts.map(Number);
  }

  for (var i = 0; i < v1parts.length; ++i) {
    if (v2parts.length == i) {
      return 1;
    }

    if (v1parts[i] == v2parts[i]) {
      continue;
    }
    else if (v1parts[i] > v2parts[i]) {
      return 1;
    }
    else {
      return -1;
    }
  }

  if (v1parts.length != v2parts.length) {
    return -1;
  }

  return 0;
}

function getParameter(param) {
  const parsedSearch = queryString();
  return parsedSearch[param];
}

const params = queryString();

let _index = 1000;

let _fakeInvoke = (eventName, cb_1, cb_2) => {
  //ignore the second callback for now, hasn't decided how to commonlize this process
  console.log(eventName);

  if (cb_2) {
    console.log(cb_2);
  }

  if (eventName == "stopRecord") {
    setTimeout(function(){
      cb_1("uploadFile");
    }, 100);
    setTimeout(function(){
      cb_2("{ \"status\": \"-11\" }");
    }, 500);
  } else {
    if ("function" === typeof cb1) {
      setTimeout(function(){cb_1(null);}, 100);
    } else {
      console.log(cb_1);
    }
  }
};

const CALLBACK_FUNCS = [
  'nativeMinimize', 
  'onActive',
  'onSuspend'
];

let isCallbackFunction = (eventName) => {
  return CALLBACK_FUNCS.indexOf(eventName) !== -1;
};

let _key = (fn, event) => {
  let key = '_cb' + _index;
  _index = _index + 1;

  window[key] = function () {
    try {
      fn.apply(window, arguments);
      if (!isCallbackFunction(event)) {
        delete window[key];
      }
    } catch(e) {
      //should exception to track server
      console.log(e);
    }

    return 'success';
  };

  return key;
};

let NativeInterface = {
  invoke: function(event, cb_1, cb_2) {
    let args = [].slice.call(arguments, 1), _len = args.length;
    for (var i = 0; i < _len; i++) {
      if (typeof args[i] === 'function') { args[i] = _key(args[i], event); }
    }

    try {
      if (params.debug === 'true') {
        _fakeInvoke(event, cb_1, cb_2);
      } else if (/iP(ad|hone|od)/.test(navigator.userAgent)) {
        if (params.appVersion >= '3.1' || params.appId === 'lingocc') {
          window.webkit.messageHandlers.LLSiOS.postMessage({
            eventName: event,
            args: args
          });
        } else {
          // old ios invoking logic
          var urlScheme = "lls://" + event + "/" + args.join('/');
          window.location = urlScheme;
        }
      } else {
        if (_len === 3) {
          window.LLSAndroid.invoke(event, args[0], args[1], args[2]);
        } else if (_len === 2) {
          window.LLSAndroid.invoke(event, args[0], args[1]);
        } else {
          window.LLSAndroid.invoke(event, args[0]);
        }
      }
    } catch(e) {
      console.log('invoke error : ', e);
    }
  }
};

const RoutesMappingV1 = {
  practice: {
    android: 'com.liulishuo.engzo.course.activity.C8ListActivity',
    ios: 'show_lesson_detail'
  },

  order: {
    android: 'com.liulishuo.engzo.course.activity.ClassgroupOrderActivity',
    ios: 'show_order'
  },

  charge: {
    android: 'com.liulishuo.engzo.iap.activity.IAPActivity',
    ios: 'show_iap'
  },

  pt_detail : {
    android: 'com.liulishuo.engzo.cc.activity.PTEntranceActivity',
    ios: 'cc_pt_entrance'
  }
};

const RoutesMappingV2 = {
  practice: {
    client: 'show_lesson_detail'
  },

  cc_practice: {
    client: 'show_cc_lesson_detail'
  },

  order: {
    client: 'show_order'
  },

  cc_order: {
    client: 'show_cc_order'
  },

  charge: {
    client: 'show_iap'
  },

  pt_detail: {
    client: 'cc_pt_entrance'
  }
};

let isOldAndroidVersion = function() {
  const appVersion = getParameter('appVersion');
  return (!/iP(ad|hone|od)/.test(navigator.userAgent) && /^\d+$/.test(appVersion));
};

const AppRoutes = {
  get(route) {
    const appVersion = getParameter('appVersion');

    //T11153 compatible with old android version naming
    if (isOldAndroidVersion()) {
      return RoutesMappingV1[route].android;
    }

    if (versionCompare(appVersion, '3.1.5', {lexicographical: 1}) < 0) {
      const mappingEntry = RoutesMappingV1[route];
      if (/iP(ad|hone|od)/.test(navigator.userAgent)) {
        return mappingEntry.ios; 
      } else {
        return mappingEntry.android;
      }
    } else {
      const mappingEntry = RoutesMappingV2[route];
      return mappingEntry.client;      
    }
  }
};

const DEFAULT_CATEGORY = 'all';
const DEFAULT_APP_NAME = 'lls';
const APP_MARKETING_VERSION = '1.0';
const TRACK_URL = 'https://flm3.llsapp.com/data_collect';

function Track(config = {}) {
  this.query = this.queryString(location.search);
  this.category = config.category || DEFAULT_CATEGORY;
  this.app_name = config.app_name || DEFAULT_APP_NAME;
  this.app_version = config.app_version || APP_MARKETING_VERSION;
}

Track.prototype = {
  makeRandomIdStr(strLen) {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let text = '';
    for(let i = 0; i < strLen; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  },
  getSessionId() {
    let sessionId = window.sessionStorage.getItem('sessionId');
    if(!sessionId) {
      sessionId = Math.floor(Date.now() / 1000) + '.' + this.makeRandomIdStr(6);
      window.sessionStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
  },
  getTempUserId() {
    return 'tmp' + this.getSessionId();
  },
  buildTrackPackage(trackData) {
    const commonData = {
      platform: this.category,
      session_id: this.getSessionId(),
      app_marketing_version: this.app_version
    };
    trackData.time = this._formatedTimeNow();
    return {
      user_id: this.getTempUserId(),
      app_name: this.app_name,
      common_data: commonData,
      batch_data: [{
        event_type: 22,
        payload: trackData
      }]
    };
  },
  _zeroFill(num, targetLength) {
    const absNum = Math.abs(num).toString();
    const zerosToFill = targetLength - absNum.length;
    return Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNum;
  },
  _formatedTimeNow() {
    const t = new Date();
    const year = t.getFullYear();
    const month = this._zeroFill(t.getMonth() + 1, 2);
    const day = this._zeroFill(t.getDate(), 2);
    const hour = this._zeroFill(t.getHours(), 2);
    const minutes = this._zeroFill(t.getMinutes(), 2);
    const seconds = this._zeroFill(t.getSeconds(), 2);
    return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
  },
  normalizeTrackpayload(params) {
    const normalizedPayload = {};
    for (let key in params) {
      normalizedPayload[this._dasherize(key)] = params[key];
    }
    return normalizedPayload;
  },
  _dasherize(str) {
    return /[A-Z]/g.test(str) ? str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase() : str;
  },
  queryString(text) {
    const query = {};
    if (text) {
      const params = text.substring(1).split('&');
      params.forEach(item => {
        const kv = item.split('=');
        query[kv[0]] = decodeURIComponent(kv[1]);
      });
    }
    return query;
  },
  xhr(options) {
    const request = new XMLHttpRequest();
    request.open(options.type, options.url, true);
    request.setRequestHeader('Content-Type', options.contentType);
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        if (typeof options.success === 'function') {
          options.success();
        }
      } else {
        if (typeof options.error === 'function') {
          options.error();
        }
      }
    };
    request.send(options.data);
  },
  send(params, success) {
    const trackData = this.normalizeTrackpayload(params);
    if(!trackData.channel && this.query.channel) {
      trackData.channel = this.query.channel;
    }
    const trackPackage = this.buildTrackPackage(trackData);
    this.xhr({
      url: TRACK_URL,
      data: JSON.stringify(trackPackage),
      type: 'POST',
      contentType: 'application/json',
      success : success || function () {}
    });
  },
  sendPageTrackEx(params = {}, success) {
    params.action = 'page_view';
    this.send(params, success);
  },
  sendActionTrackEx(params, success) {
    this.send(params, success);
  },
  sendPageTrack(pageName, category, params, afterTrack) {
    params = params || {};
    params.pageName = pageName;
    params.category = category || this.category;
    this.extendSourceTypeParams(params);
    NativeInterface.invoke('doPage', () => {
      if (typeof afterTrack === 'function') {
        afterTrack();
      }
    }, JSON.stringify(params));
  },
  sendActionTrack(actionName, params, afterTrack) {
    params = params || {};
    params.action = actionName;
    params.channel = this.query.channel || '';
    this.extendSourceTypeParams(params);
    NativeInterface.invoke('doAction', () => {
      if (typeof afterTrack === 'function') {
        afterTrack();
      }
    }, JSON.stringify(params));
  },
  sendTrack(type = 'page', actionOrPageName, success) {
    if (type === 'page') {
      this.sendPageTrack({
        pageName: actionOrPageName
      }, success);
    } else {
      this.sendActionTrack({
        action: actionOrPageName
      }, success);
    }
  },
  extendSourceTypeParams(params) {
    const orderSourceType = this.query.orderSourceType;
    if (orderSourceType) {
      params.source_type = orderSourceType;
    }
  }
};

const track = new Track();

function CountDown(config) {
  this.day = config.day;
  this.hour = config.hour;
  this.minute = config.minute;
  this.startTime = new Date().getTime();
  this.endTime = new Date(config.dateline).getTime();
  this._time = { day: 0, hour: 0, minute: 0 };
}

CountDown.prototype = {
  init() {
    setInterval(() => {
      this.render();
    }, 1000);
  },
  getCountdown() {
    this.startTime = new Date().getTime();
    this.countdown = (this.endTime - this.startTime) / 1000;
    const day = Math.floor(this.countdown / (24 * 3600));
    const hour = Math.floor(this.countdown % (24 * 3600) / 3600) - 8; // 减去 +8 时区差
    const minute = Math.floor(this.countdown % (24 * 3600) % 3600 / 60);
    return { day, hour, minute };
  },
  template(number) {
    number = number.toString();
    if (number.length === 1) {
      return `<span>0</span><span>${number}</span>`;
    } else {
      return `<span>${number[0]}</span><span>${number[1]}</span>`;
    }
  },
  render() {
    this.time = this.getCountdown();
    if (this._time.day !== this.time.day) {
      this._time.day = this.time.day;
      this.day.innerHTML = this.template(this.time.day);
    }
    if (this._time.hour !== this.time.hour) {
      this._time.hour = this.time.hour;
      this.hour.innerHTML = this.template(this.time.hour);
    }
    if (this._time.minute !== this.time.minute) {
      this._time.minute = this.time.minute;
      this.minute.innerHTML = this.template(this.time.minute);
    }
  },
};

const $countdown = document.getElementById('countdown');
const countdown = new CountDown({
  day: $countdown.querySelector('.day'),
  hour: $countdown.querySelector('.hour'),
  minute: $countdown.querySelector('.minute'),
  dateline: '2017-07-16',
});
countdown.init();

track.sendPageTrack('landing', 'campaign', {
  campaign_name: 'cc_626_activity'
});

document.querySelector('.buy').addEventListener('click', function () {
  track.sendActionTrack('click_grab', {
    page_name: 'landing',
    category: 'campaign',
    campaign_name: 'cc_626_activity'
  });
  NativeInterface.invoke('navigate', JSON.stringify({
    url: AppRoutes.get('cc_order'),
    param: {
      packageId: getEnv() === 'staging' ? 566 : 504
    },
    closeWebview: !isIOS()
  }));
});

}());
